import axios from 'axios';

import ENDPOINTS from 'tradera-constants/endpoints';
import {
    axiosConfigs,
    axiosWithTokenRefresh,
    utilizeCancelToken,
    finalizeResponse,
    handleError,
    API_ERRORS
} from 'tradera-utils/api';

function getSystemMessages() {
    return axiosWithTokenRefresh()
        .get(ENDPOINTS.MEMBER_SYSTEM_MESSAGES, {
            ...axiosConfigs.authenticated
        })
        .then(finalizeResponse())
        .catch(
            handleError({
                // Ignore 400 & 401 errors that slip through token refresh
                400: API_ERRORS.IGNORE_ME,
                401: API_ERRORS.IGNORE_ME
            })
        );
}

function getMessagingNotifications() {
    const { cancel, cancelToken } = utilizeCancelToken(
        'fetchMessagingNotifications'
    );
    if (cancel) cancel();
    return axios
        .get(ENDPOINTS.MESSAGING_NOTIFICATIONS, {
            cancelToken,
            ...axiosConfigs.authenticated
        })
        .then(finalizeResponse())
        .catch(handleError());
}

function getDismissSwish() {
    return axios
        .get(ENDPOINTS.PAYMENT_SWISH_OPTOUT, {
            ...axiosConfigs.authenticated
        })
        .then(finalizeResponse())
        .catch(handleError());
}

export { getSystemMessages, getMessagingNotifications, getDismissSwish };
